/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 判断当前用户和票夹详情中用户是否是同一个
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  ticketFolderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/user/${ticketFolderId}/validation`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
